<template>
    <div class="user-card" v-loading="loading">
        <div class="user-info">
            <div class="avathor">
                <img v-if="!isUnbind && userData.avatar.substr(0,1) !== '?'" :src="userData.avatar">
                <img v-else src="../../images/personal_center/avatar_default.png" alt="">
            </div>
            <div class="info">
                <div class="user-name">
                    {{ userData.nick_name }}
                    <el-tooltip v-if="userData.is_official" effect="light" content="蓝鲸智云官方" placement="right">
                        <svg style="width: 18px; height: 18px; vertical-align: text-bottom;" aria-hidden="true">
                            <use xlink:href="#icon-lanjingguanfang"></use>
                        </svg>
                    </el-tooltip>
                    <el-tooltip v-if="userData.is_vip" effect="light" content="核心用户" placement="right">
                        <span class="icon-vipuser"></span>
                    </el-tooltip>
                </div>
                <div v-if="isUnbind">该用户已注销</div>
                <template v-else>
                    <div class="user-desc">{{ userData.signature_label || '这个人很懒，什么都没有留下'}}</div>
                    <div class="user-jion">加入时间：{{ userData.register_time }}</div>
                    <ul class="user-awards">
                        <li v-for="(item, index) in honorList" :key="index" :title="item.medal.name">
                            <img style="width: 20px; height: 20px;" :src="item.medal.icon_on" alt="">
                        </li>
                    </ul>
                </template>
            </div>
            <el-button v-if="follow.is_mutual_follow" class="user-attention" style="background: #989ba5; color: #fff" @click="unfollowUser">
                <span class="display">相互关注</span>
                <span class="hover-display">取消关注</span>
            </el-button>
            <template v-else>
                <el-button v-if="follow.is_followed" class="user-attention" @click="unfollowUser">
                    <span class="display">已关注</span>
                    <span class="hover-display">取消关注</span>
                </el-button>
                <el-button v-else :type="disable ? 'default' : 'primary'" :disabled="isUnbind || disable" class="user-attention" style="background: #989ba5; color: #fff" icon="el-icon-plus" @click="followUser">关注</el-button>
            </template>
        </div>
        <div class="user-dynamic">
            <template v-if="!isUnbind">
                <div class="dynamic-list" v-for="item in dynamicData" :key="item.name">
                    <p>{{ item.name }}</p>
                    <p class="nums" @click="goToPage(item)">{{ item.nums }}</p>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import bus from '@/js/bus.js'
export default {
    name: 'userCard',
    props: {
        userId: Number
    },
    data () {
        return {
            user: {},
            disable: false,
            loading: false,
            userData: {
                avatar: '',
                signature_label: '',
                follow_time: '',
                is_vip: '',
                nick_name: '',
                register_time: ''
            },
            follow: {
                is_followed: false,
                is_mutual_follow: false
            },
            honorList: [],
            isUnbind: false,
            dynamicData: [
                {
                    name: '提问',
                    key: 'qa_num',
                    nums: 0
                },
                {
                    name: '回答',
                    key: 'comment_num',
                    nums: 0
                },
                {
                    name: '文章',
                    key: 'article_num',
                    nums: 0
                }
            ]
        }
    },
    watch: {
        '$store.state.userInfo': {
            handler (state) {
                this.user = state
            },
            deep: true,
        }
    },
    methods: {
        init () {
            this.getUserInfo()
        },
        getUserInfo () {
            this.loading = true
            this.disable = this.$store.state.userInfo.user_id === this.userId
            // 查询用户信息
            const userInfo = axios.get(myUrl + `profile/user/${this.userId}/head/`)
            // 查询用户荣誉
            const honorInfo = axios.get(myUrl + `profile/honor/?user=${this.userId}`)
            // 查询用户提问、问答、 文章数
            const statisticInfo = axios.get(myUrl + `/profile/user/${this.userId}/statistics/`)
            Promise.all([userInfo, honorInfo, statisticInfo]).then(res => {
                const { signature_label, avatar, nick_name, is_vip, follow_time, is_mutual_follow, is_followed, register_time } = res[0].data.data
                this.userData.avatar = avatar
                this.userData.nick_name = nick_name
                this.userData.signature_label = signature_label
                this.userData.is_vip = is_vip
                this.userData.register_time = register_time
                this.userData.follow_time = follow_time
                this.honorList = res[1].data.data.results
                const { qa_num, article_num, comment_num } = res[2].data.data
                this.dynamicData[0].nums = qa_num
                this.dynamicData[1].nums = comment_num
                this.dynamicData[2].nums = article_num

                if (!is_mutual_follow) {
                    this.follow.is_mutual_follow = false
                    this.follow.is_followed = is_followed
                } else {
                    // 互相关注
                    this.follow.is_mutual_follow = true
                    this.follow.is_followed = true
                }
            }).catch(e => {
                this.isUnbind = e.data.code === '00'
            }).finally(_ =>{
                this.loading = false
            })
        },
        // 关注
        followUser () {
            // 校验信息是否完善
            if (!this.$store.state.informationComplete) {
                bus.$emit('openInformationPopup');
                return;
            }
            axios.post(myUrl + `sns/star/user/${this.userId}/`).then(res => {
                this.$message({
                    message: res.data.message,
                    type: 'success'
                })
                this.getUserInfo()
            })
        },
        // 取消关注
        unfollowUser () {
            // 校验信息是否完善
            if (!this.$store.state.informationComplete) {
                bus.$emit('openInformationPopup');
                return;
            }
            axios.post(myUrl + `sns/unstar/user/${this.userId}/`).then(res => {
                this.$message({
                    message: res.data.message,
                    type: 'success'
                })
            })
            this.getUserInfo()
        },
        // 跳转对应页面
        goToPage (item) {
            let path = ''
            let query = {}
            if (item.key === 'article_num') {
                path = `/s-mart/personal_center/article/${this.userId}`
            } else {
                path = `/s-mart/personal_center/question/${this.userId}`
                query.tabName = item.key === 'qa_num' ? 'my_question' : 'my_answer'
            }
            const routeData = this.$router.resolve({
                path,
                query
            })
            window.open(routeData.href, '_blank')
        }
    }
}
</script>

<style lang="scss" scoped>
.user-card {
    width: 400px;
    height: 218px;
    text-align: left;
    display: flex;
    flex-direction: column;
    .user-info {
        display: flex;
        min-height: 120px;
        background-color: #f0f5ff;
        padding: 10px 16px;
        .avathor {
            width: 48px;
            height: 48px;
            border-radius: 50%;
            overflow: hidden;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .info {
            overflow: hidden;
            flex: 1;
            padding: 0 8px;
            display: flex;
            flex-direction: column;
            font-size: 12px;
            .user-name {
                font-size: 14px;
                height: 22px;
                line-height: 22px;
                font-family: MicrosoftYaHei-Bold;
                color: #313238;
                font-weight: Bold;
                white-space: nowrap;
                word-break: break-all;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .user-desc {
                height: 20px;
                line-height: 20px;
                white-space: nowrap;
                word-break: break-all;
                overflow: hidden;
                text-overflow: ellipsis;
                color: #63656E;
            }
            .user-jion {
                height: 20px;
                line-height: 20px;
                color: #979BA5;
                white-space: nowrap;
                word-break: break-all;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .user-awards {
                display: flex;
                flex-wrap: wrap;
                li {
                    width: 18px;
                    height: 18px;
                    margin-right: 2px;
                    margin-top: 2px;
                }
            }
        }
        .user-attention {
            margin-top: 20px;
            font-size: 12px;
            line-height: 26px;
            text-align: center;
            width: 68px;
            height: 26px;
            padding: 0;
            .display {
                display: block;
            }
            .hover-display {
                display: none;
            }
            &:hover {
                .display {
                    display: none;
                }
                .hover-display {
                    display: block;
                }
            }
        }
    }
    .user-dynamic {
        width: 100%;
        flex: 1;
        display: flex;
        .dynamic-list {
            // height: 94px;
            flex: 1;
            align-items: center;
            padding: 24px 0;
            display: flex;
            flex-direction: column;
            .nums {
                display: inline-block;
                margin-top: 8px;
                cursor: pointer;
                &:hover {
                    color: #3a84ff;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// userCard.vue?84b14c8c